/**
 * Formatting helpers — one import for money/percent, and the place the
 * privacy mask actually happens.
 *
 * Masking substitutes `$••••` at the formatting layer (the Robinhood
 * treatment) rather than blurring elements. That's what makes it complete and
 * *only* complete: every dollar figure in the app flows through these two
 * functions or through `<Money>`, so amounts mask without any component
 * opting in — and text that merely mentions money ("covers 6.4 months of
 * fixed costs") stays readable, because it never was an amount.
 *
 * The flag is a module global, which only works because toggling it re-renders
 * the whole tree (see `masked` in lib/store — the shell subscribes and React
 * re-renders everything under it, re-running every fmtMoney call). shared/
 * keeps its pure formatter for tests and worker code.
 */
import {
  fmtMoney as pureFmtMoney,
  fmtMoneyK as pureFmtMoneyK,
} from '@shared/finance';
import { compactMoney as pureCompact } from '@vitness/charts';

export {
  fmtPct, totalNetWorth, monthlyAmount, emergencyFundPct, effectiveTaxPct,
} from '@shared/finance';

export const MASKED_AMOUNT = '$••••';

let masked = false;

/** Set by the store before the tree re-renders. Not for component use. */
export function setMaskFlag(on: boolean): void {
  masked = on;
}

export function isMasked(): boolean {
  return masked;
}

export function fmtMoney(v: number, decimals?: number): string {
  return masked ? MASKED_AMOUNT : pureFmtMoney(v, decimals);
}

export function fmtMoneyK(v: number): string {
  return masked ? MASKED_AMOUNT : pureFmtMoneyK(v);
}

export function compactMoneyFmt(v: number): string {
  return masked ? MASKED_AMOUNT : pureCompact(v);
}
